import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons';
import { format, parseISO } from 'date-fns';

@Component({
  selector: 'mom-form-field-date',
  templateUrl: './form-field-date.component.html',
  styleUrls: ['./form-field-date.component.scss']
})
export class FormFieldDateComponent implements OnInit {
  @Input() id: string;
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() labelPosition: 'fixed' | 'floating' | 'stacked' = 'floating';
  @Input() placeholder: string;
  @Input() presentation: 'date' | 'date-time' = 'date';
  @Input() required: boolean;
  @Input() min: string;
  @Input() max: string;

  calendarFormattedDate: string;
  faCalendarDay = faCalendarDay;
  isWeb: boolean;

  constructor() {
    this.isWeb = Capacitor.getPlatform() === 'web';
  }

  private get format(): string {
    return this.presentation === 'date' ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm";
  }

  ngOnInit(): void {
    if (this.formCtrl.value) {
      this.formCtrl.setValue(this.formatDate(new Date(this.formCtrl.value)), { emitEvent: false });
    }

    this.formCtrl.valueChanges.subscribe((date) => {
      this.calendarFormattedDate = this.formatDate(new Date(date));
    });
    this.calendarFormattedDate = this.formCtrl.value ? this.formatDate(new Date(this.formCtrl.value)) : this.formatDate(new Date());
  }

  onCalendarChange(event: any): void {
    this.mapDate(event.detail.value);
  }

  private mapDate(date: string): void {
    this.formCtrl.setValue(format(parseISO(date), this.format));
  }

  private formatDate(date: Date): string {
    return format(date, this.format);
  }
}
